import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    data: {
      user_pet: '',
    },
  },
  mutations: {
    fetchData: (state, info) => {
      if(info.user_pet) {
        info.user_pet.filter((item) => {
          item.editableFlag = true
          return item
        })
        state.data = info
      } else {
        state.data = []
      }
    },
    addData: (state, info) => {
      info.user_pet.editableFlag = true
      state.data.user_pet.push(info.user_pet)
    },
    updateData: (state, info) => {
      return state.data.user_pet = state.data.user_pet.map((item) => {
        if (item.id == info.id) {
          item = info
        }
        return item
      })
    },
    removeData: (state, info) => {
      return state.data.user_pet = state.data.user_pet.map((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchData ({commit, rootState}) {
      const response = await axios.get('admin/users/data/'+rootState.user.currentUser)
      commit ('fetchData', response.data.user_data)
    },
    async updateData ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.put('admin/user/data/pet/'+data.id, data)
      commit ('updateData', response.data)
    },
    async addData ({commit, rootState}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      data.user_id = rootState.user.currentUser
      const response = await axios.post('admin/user/data/pet', data)
      commit ('addData', response.data)
    },
    async removeData ({commit}, id) {
      await axios.delete('admin/user/data/pet/'+id).then(() => {
        commit ('removeData', id)
      })
    },
  }
}
export default module
